import * as React from 'react';
import Helmet from 'react-helmet';
import {styled, mq, parseQueryString} from '../../utils';
import ResetPasswordForm from '../../containers/ResetPasswordForm';
import {Main} from '../../components/AuthLayout';
import {RouteComponentProps} from 'react-router';

const PageTitle = styled('h1')(({theme}) => ({
  fontFamily: theme.fontFamily.base,
  fontSize: 38,
  marginBottom: 19,
  [mq('laptop')]: {
    fontSize: 42,
    marginBottom: 21
  },
  [mq('desktop')]: {
    fontSize: 50,
    marginBottom: 25
  }
}));

interface WithInjectedProps extends RouteComponentProps {}

export default class ResetPassword extends React.Component<{}, {}> {
  public render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>Reset your password</title>
        </Helmet>
        <Main narrow={true} style={{marginTop: 200}}>
          <PageTitle>Reset your password</PageTitle>
          <ResetPasswordForm token={this._searchParams.token} />
        </Main>
      </React.Fragment>
    );
  }

  private get _withInjectedProps() {
    return this.props as WithInjectedProps;
  }

  private get _searchParams() {
    return parseQueryString(this._withInjectedProps.location.search);
  }
}



// WEBPACK FOOTER //
// ./src/pages/ResetPassword/ResetPassword.tsx